export default __webpack_public_path__ + "static/media/NT.36993d56.svg";